import { ApplicationConfig, importProvidersFrom, provideZonelessChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { routes } from "./app.routes";
import { provideClientHydration, withNoIncrementalHydration } from "@angular/platform-browser";
import "leaflet.markercluster";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from "@angular/common/http";
import { mockInterceptor } from "./interceptors/mock/mock.interceptor";
import { cacheInterceptor } from "./interceptors/cache/cache.interceptor";
import { ConfirmationService, MessageService } from "@openng/optimus-ui/api";

import { httpHeadersInterceptor } from "./interceptors/http-headers/http-headers.interceptor";
import { DialogService } from "@openng/optimus-ui/dynamicdialog";
import { GateIdentifierPipe } from "./shared/pipes/gateIdentifier/gate-identifier.pipe";
import { DecimalPipe } from "@angular/common";
import { timeoutInterceptor } from "./interceptors/timeout/timeout.interceptor";
import { blobErrorInterceptor } from "./interceptors/blob-error/blob-error.interceptor";
import { provideOptimus } from "@openng/optimus-ui/config";
import { BotevoPreset } from "../assets/themes/botevoPreset";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideClientHydration(withNoIncrementalHydration()),
    provideOptimus({
      theme: {
        preset: BotevoPreset,
        options: {
          darkModeSelector: ".darkmode",
        },
      },
    }),
    provideHttpClient(
      withInterceptors([
        httpHeadersInterceptor,
        timeoutInterceptor,
        cacheInterceptor,
        mockInterceptor,
        blobErrorInterceptor,
      ]),
      withFetch()
    ),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    MessageService,
    ConfirmationService,
    DialogService,
    GateIdentifierPipe,
    DecimalPipe,
  ],
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
